<template>
  <div id="footer" class="container-fluid ">
    <!-- <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div> -->
    <p v-if="footer.pengyan_footer_title != ''" class="title wow bounce">
      {{ footer.pengyan_footer_title }}
    </p>
    <p class="email_wx">
      <span style="margin-right: 10px;" v-if="footer.pengyan_footer_email != ''"
        >邮箱：{{ footer.pengyan_footer_email }}</span
      >
      <span
        style="margin-right: 10px;"
        v-if="footer.pengyan_footer_wechat != ''"
        >微信号：{{ footer.pengyan_footer_wechat }}</span
      >
      <span v-if="footer.pengyan_footer_phone != ''"
        >电话：{{ footer.pengyan_footer_phone }}</span
      >
    </p>
    <div class="address_tel_fax" v-if="footer.pengyan_footer_adderss != ''">
      <p>地址：{{ footer.pengyan_footer_adderss }}</p>
    </div>

    <p class="copy">
      <span
        class="copy-item"
        style="margin-right: 20px;"
        v-if="footer.pengyan_footer_copyright != ''"
      >
        {{ footer.pengyan_footer_copyright }}
      </span>
      <span
        class="copy-item"
        style="cursor: pointer;"
        @click="openNewWindow('https://beian.miit.gov.cn/')"
        v-if="footer.pengyan_footer_beian != ''"
      >
        {{ footer.pengyan_footer_beian }}
      </span>
    </p>
  </div>
</template>
<script>
import { getFooter } from "@/api/api";
import { WOW } from "wowjs";
export default {
  name: "Footer",
  data() {
    return {
      footer: {
        pengyan_footer_title: "",
        pengyan_footer_email: "",
        pengyan_footer_wechat: "",
        pengyan_footer_phone: "",
        pengyan_footer_adderss: "",
        pengyan_footer_copyright: "",
        pengyan_footer_beian: ""
      }
    };
  },
  mounted() {
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
    this.getIndex();
  },
  methods: {
    getIndex() {
      getFooter({}).then(response => {
        this.footer = response.data.data
        console.log(this.footer);
      });
    },
    openNewWindow(url) {
      window.open(url, "_blank");
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #6a6968;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
  margin-top: 40px;
}
.address_tel_fax {
  color: #fff;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #fff;
  font-size: 14px;
}
.copy {
  color: #fff;
  font-size: 14px;
  /* margin: 50px 0 10px; */
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    /* margin: 30px 0 10px; */
  }
  .copy-item {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue